const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const formatINR = (n) => `₹${Number(n).toLocaleString("en-IN")}`;

export const discountOf = (p) => Math.round(((p.mrp - p.price) / p.mrp) * 100);

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72 });
  else el.scrollIntoView({ behavior: "smooth" });
}

async function handle(res) {
  if (!res.ok) {
    let msg = `Request failed (${res.status})`;
    try {
      const data = await res.json();
      if (data.detail) msg = typeof data.detail === "string" ? data.detail : msg;
    } catch (_) {}
    throw new Error(msg);
  }
  return res.json();
}

export function fetchCategories() {
  return fetch(`${API}/categories`).then(handle);
}

export function fetchProducts({ category, q, minDiscount } = {}) {
  const params = new URLSearchParams();
  if (category) params.set("category", category);
  if (q) params.set("q", q);
  if (minDiscount) params.set("min_discount", String(minDiscount));
  return fetch(`${API}/products?${params.toString()}`).then(handle);
}

export function createOrder(payload) {
  return fetch(`${API}/orders`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  }).then(handle);
}
